/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Moment from 'moment';
import {
  calculateDebtForDay,
  calculatePayments,
  calculateFinalPayment,
} from '../../utils/calculate';

export const RESET = 'RESET';
export const UPDATE_DAY_DATA = 'UPDATE_DAY_DATA';
export const QUESTION_0_FINISH = 'QUESTION_0_FINISH';
export const QUESTION_1_FINISH = 'QUESTION_1_FINISH';
export const QUESTION_2_FINISH = 'QUESTION_2_FINISH';
export const QUESTION_2_BACK = 'QUESTION_2_BACK';
export const QUESTION_3_FINISH = 'QUESTION_3_FINISH';
export const QUESTION_3_BACK = 'QUESTION_3_BACK';
export const QUESTION_3_RELOAD = 'QUESTION_3_RELOAD';

export const QUESTION_4_FINISH = 'QUESTION_4_FINISH';
export const QUESTION_4_BACK = 'QUESTION_4_BACK';
export const QUESTION_4_RELOAD = 'QUESTION_4_RELOAD';

export const QUESTION_5_FINISH = 'QUESTION_5_FINISH';
export const QUESTION_5_BACK = 'QUESTION_5_BACK';
export const RESULTS_BACK = 'RESULTS_BACK';

export const initialState = {
  dayData: undefined,
  currentQuestionNum: 0,
  incurredAmount: undefined,
  incurredDate: undefined,
  finalPaymentDate: undefined,
  todaysDateString: undefined,
  amountRemainingToday: undefined,
  interestRemainingToday: undefined,
  paymentFrequency: undefined,
  paymentFrequencyAmount: undefined,
  paymentFrequencyStartDate: undefined,
  installments: [],
  payments: [],
  rangeFirstDate: undefined,
  rangeInstallmentAmount: undefined,
  rangeFinalDate: undefined,
  rangeFrequency: undefined,
  // maxLastPaymentDate: new Moment().add(5, 'years'),
};

const isToday = date => {
  const today = Moment().startOf('day');
  const inDate = Moment(date).startOf('day');
  // console.log([today, inDate, today.isSame(inDate)]);
  return today.isSame(inDate);
};

export const reducer = (state, action) => {
  let newState = { ...state };

  if (action.type === UPDATE_DAY_DATA) {
    newState.dayData = action.payload.dayData;
    newState.finalDay = newState.dayData.finalDay;
  }

  if (action.type === RESET) {
    newState = initialState;
    newState.dayData = state.dayData;
    newState.currentQuestionNum = 1;
  }

  if (action.type === QUESTION_0_FINISH) {
    newState.currentQuestionNum = 1;
  }

  if (action.type === QUESTION_1_FINISH) {
    newState.incurredDate = action.payload.startDate;
    newState.finalPaymentDate = action.payload.finalPaymentDate;
    newState.incurredAmount = parseFloat(action.payload.amount);

    newState.currentQuestionNum = 2;
  }

  if (action.type === QUESTION_2_BACK) {
    newState.currentQuestionNum = 1;
  }

  if (action.type === QUESTION_2_FINISH) {
    newState.installments = action.payload.installments;
    const [amountRemaining, interestRemaing, todaysDateString] =
      calculateDebtForDay(newState);
    newState.installments = action.payload.installments;
    newState.todaysDateString = todaysDateString;
    newState.amountRemainingToday = amountRemaining;
    newState.interestRemainingToday = interestRemaing;
    newState.currentQuestionNum = 3;
  }

  if (action.type === QUESTION_3_BACK) {
    if (isToday(state.incurredDate)) {
      newState.currentQuestionNum = 1;
    } else {
      newState.currentQuestionNum = 2;
    }
  }

  if (action.type === QUESTION_3_FINISH) {
    newState = {
      ...newState,
      ...action.payload,
      currentQuestionNum: 5,
      loading: true,
      payments: calculatePayments(newState),
    };

    const [amountRemaining, interestRemaing, todaysDateString] =
      calculateDebtForDay(newState);

    newState.todaysDateString = todaysDateString;
    newState.amountRemainingToday = amountRemaining;
    newState.interestRemainingToday = interestRemaing;
  }

  if (action.type === QUESTION_3_RELOAD) {
    newState = {
      ...newState,
      finalPaymentDate: action.payload.finalPaymentDate,
      currentQuestionNum: 3,
    };

    const [amountRemaining, interestRemaing, todaysDateString] =
      calculateDebtForDay(newState);

    newState.todaysDateString = todaysDateString;
    newState.amountRemainingToday = amountRemaining;
    newState.interestRemainingToday = interestRemaing;
  }

  if (action.type === QUESTION_4_FINISH) {
    newState.currentQuestionNum = 5;
    newState.paymentFrequency = action.payload.paymentFrequency;
    newState.paymentFrequencyAmount = action.payload.paymentFrequencyAmount;
    newState.paymentFrequencyStartDate =
      action.payload.paymentFrequencyStartDate;
    newState.loading = true;
    newState.payments = calculatePayments(newState);
  }

  if (action.type === QUESTION_4_BACK) {
    newState.currentQuestionNum = 3;
  }

  if (action.type === RESULTS_BACK) {
    newState.currentQuestionNum = 3;
    newState.loading = false;
  }
  return newState;
};
